import {
    ChevronDownIcon,
    Datepicker,
    DateRangeType,
    Dropdown,
    Flex,
    Input,
    Text,
} from "@fluentui/react-northstar";
import React, { useMemo, useState } from "react";
import DropdownRemote from "../DropdownRemote/DropdownRemote";
import SliderTabs from "../../../../components/shared/SliderTabs";
import { Controller, useFormContext } from "react-hook-form";
import { ErrorMessage } from "../../../../common/styles";
import { TIMES_SPLIT_DAY_TO_INDEX } from "../../constants";
import { ArrowRepeatAll20Regular } from "@fluentui/react-icons";
import moment from "moment";
import styled from "styled-components";

const Content = ({
    eventType = false,
    repeat,
    until_date,
    isModeUpdate = false,
}) => {
    const [open, setOpen] = useState(false);
    const {
        control,
        setValue,
        getValues,
        trigger,
        formState: { errors },
        watch,
    } = useFormContext();

    const recurrencyRemoteJob = [
        {
            id: 0,
            content: "Ne pas répéter",
        },
        {
            id: 1,
            content: "Semaine",
        },
        {
            id: 2,
            content: "2 semaines",
        },
        {
            id: 3,
            content: "3 semaines",
        },
        {
            id: 4,
            content: "4 semaines",
        },
    ];
    const formattedRecurrencyRemoteJob = useMemo(() => {
        return recurrencyRemoteJob?.map((item) => ({
            key: item.id,
            header: item.content,
        }));
    }, [recurrencyRemoteJob]);

    const start_date = getValues("start_date");
    const minDate = start_date ? new Date(start_date) : undefined;

    // const defaultDate = until_date
    //     ? until_date
    //     : moment(start_date).add(6, "months").toDate();

    const defaultDate = start_date
        ? moment(start_date).add(6, "months").toDate()
        : undefined;
    const maxDate = start_date
        ? moment(start_date).add(12, "months").toDate()
        : undefined;

    const renderRepeatContent = (repeatValue) => {
        switch (repeatValue) {
            case 0:
                return null;

            default:
                return (
                    <Flex column styles={{ gap: "4px", marginTop: "12px" }}>
                        <Text>
                            A lieu toutes les{" "}
                            {repeatValue === 1 ? "semaines" : "deux semaines"},
                            le{" "}
                            <b>
                                {moment(getValues("start_date")).format("dddd")}
                            </b>{" "}
                            jusqu'au{" "}
                        </Text>

                        <Controller
                            control={control}
                            name="until_date"
                            render={({ field: { onChange, value, ref } }) => {
                                return (
                                    <Datepicker
                                        open={open}
                                        dateRangeType={DateRangeType.Day}
                                        onDateChange={(e, i) => {
                                            if (i?.value) {
                                                onChange(i.value); // met à jour le formulaire
                                                setOpen(false); // ferme le calendrier
                                            }
                                        }}
                                        defaultSelectedDate={
                                            // value ?? defaultDate
                                            until_date
                                                ? moment(until_date).toDate()
                                                : defaultDate
                                        }
                                        today={new Date()}
                                        buttonOnly
                                        popup={{
                                            open,
                                            position: "below", // 👈 Ceci positionne le calendrier en bas
                                            align: "center", // optionnel : left, right, center
                                            onOpenChange: (e, i) => {
                                                setOpen(i.open);
                                            },
                                            trigger: (
                                                <Flex
                                                    vAlign="center"
                                                    gap="gap.small"
                                                >
                                                    <TriggerStyle
                                                        content={
                                                            value
                                                                ? moment(
                                                                      value
                                                                  ).format(
                                                                      "DD MMMM YYYY"
                                                                  )
                                                                : moment(
                                                                      until_date
                                                                  ).format(
                                                                      "DD MMMM YYYY"
                                                                  )
                                                        }
                                                    />
                                                    <ChevronDownIcon
                                                        rotate={open ? 180 : 0}
                                                    />
                                                </Flex>
                                            ),
                                        }}
                                        minDate={minDate}
                                        maxDate={maxDate}
                                    />
                                );
                            }}
                        />
                    </Flex>
                );
        }
    };

    return (
        <Flex
            column
            gap="gap.small"
            styles={{
                marginTop: "24px",
                paddingBottom: "114px",
            }}
        >
            <Flex>
                <DropdownRemote
                    onChangeItem={(reason_value) => {
                        return setValue("reason", reason_value);
                    }}
                    defaultValues={{
                        selectedIndexItem: getValues("reason") ?? 1,
                    }}
                />
            </Flex>
            <Flex column styles={{ gap: "4px" }}>
                <div>
                    <Controller
                        control={control}
                        name="start_date"
                        render={({ field: { onChange, value, ref } }) => {
                            return (
                                <Input
                                    label="Commence le"
                                    type="date"
                                    defaultValue={getValues("start_date")}
                                    ref={ref}
                                    onChange={(e, i) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        onChange(i.value);
                                        trigger();
                                        return;
                                    }}
                                    error={errors?.start_date?.message}
                                />
                            );
                        }}
                    />
                </div>
                {errors?.start_date && (
                    <ErrorMessage content={errors.start_date.message} />
                )}
                <SliderTabs
                    tabs={["Début de journée", "Début d'après-midi"]}
                    defaultActiveIndex={getValues("start_time")}
                    onChange={(data) => {
                        return setValue("start_time", data);
                    }}
                    styles={{
                        width: "fit-content!important",
                    }}
                />
            </Flex>
            <Flex column styles={{ gap: "4px" }}>
                <div>
                    <Controller
                        control={control}
                        name="end_date"
                        render={({ field: { onChange, value, ref } }) => {
                            return (
                                <Input
                                    label="Fini le"
                                    type="date"
                                    error={errors?.end_date?.message}
                                    ref={ref}
                                    defaultValue={getValues("end_date")}
                                    onChange={(e, i) => {
                                        onChange(i.value);
                                        trigger();
                                        return;
                                    }}
                                />
                            );
                        }}
                    />
                </div>
                {errors?.end_date && (
                    <ErrorMessage content={errors.end_date.message} />
                )}
                <SliderTabs
                    tabs={["Fin de matinée", "Fin de journée"]}
                    defaultActiveIndex={getValues("end_time")}
                    onChange={(data) => {
                        return setValue("end_time", data);
                    }}
                    styles={{
                        width: "fit-content!important",
                    }}
                />
                {(eventType.serieEvent || !isModeUpdate) && (
                    <Flex column styles={{ marginTop: "24px" }}>
                        <Text content="Répétition" />
                        <Dropdown
                            // name="repeat"
                            fluid
                            items={formattedRecurrencyRemoteJob}
                            defaultValue={formattedRecurrencyRemoteJob?.filter(
                                (item) => item?.key === watch("repeat")
                            )}
                            checkable
                            selectedIndexItems={[getValues("repeat")]}
                            onChange={(e, i) => {
                                setValue("repeat", i.value.key);
                                setValue("until_date", defaultDate);
                            }}
                            getA11ySelectionMessage={{
                                onAdd: (item) => `${item} has been selected.`,
                            }}
                        />

                        {renderRepeatContent(watch("repeat"))}
                    </Flex>
                )}
            </Flex>
        </Flex>
    );
};

export default Content;

const TriggerStyle = styled(Text)`
    color: #5b5fc7;
    cursor: pointer;
`;
